import { useEffect } from 'react';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

type HapticKind = 'selection' | 'light' | 'medium';

const impactStyle: Record<HapticKind, ImpactStyle> = {
  selection: ImpactStyle.Light,
  light: ImpactStyle.Light,
  medium: ImpactStyle.Medium
};

async function triggerHaptic(kind: HapticKind) {
  try {
    await Haptics.impact({ style: impactStyle[kind] });
  } catch {
    // Browsers without vibration support should keep the click behavior unchanged.
  }
}

export default function useHapticFeedback() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const control = target.closest<HTMLElement>('[data-haptic]');
      if (!control || control.matches(':disabled') || control.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const kind = control.dataset.haptic as HapticKind | undefined;
      if (kind) void triggerHaptic(kind);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);
}
